import {initVanilla} from './utils/vanilla.js';
import {initializeForms} from './utils/forms.js';
import {addBootgrid, fancybox, googleAnalytics} from './utils/library_initializers.js';

$(document).ready(function() {
    initVanilla();

    if ($('form, select').length) {
        initializeForms();
    }

    if ($('.bootgrid-basic').length) {
        addBootgrid();
    }

    fancybox();

    googleAnalytics();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': window['_token']
        }
    });
});
